import { read, utils } from "@e965/xlsx";

const MAX_XLSX_BYTES = 5 * 1024 * 1024;

const XLSX_MIME = new Set([
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
]);

const XLSX_EXT = /\.(xlsx|xls)$/i;

export const parseNotificationSpreadsheet = (file) =>
  new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error("No file selected"));
      return;
    }
    if (file.size > MAX_XLSX_BYTES) {
      reject(new Error("Spreadsheet is too large (max 5MB)."));
      return;
    }
    const nameOk = XLSX_EXT.test(file.name || "");
    const mimeOk = !file.type || XLSX_MIME.has(file.type);
    if (!nameOk && !mimeOk) {
      reject(new Error("Only .xlsx or .xls workbooks are allowed."));
      return;
    }

    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const binaryData = event.target.result;
        const workbook = read(binaryData, { type: "binary" });
        const worksheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[worksheetName];
        const jsonData = utils.sheet_to_json(worksheet, { header: 1 });
        const headers = jsonData[0];
        const data = jsonData.filter((dat) => dat.length > 1).slice(1);
        const dataArray = data.map((row) => {
          const obj = {};
          headers.forEach((header, index) => {
            obj[header] = row[index];
          });
          return obj;
        });
        resolve(dataArray);
      } catch (err) {
        reject(err);
      }
    };
    reader.onerror = () => reject(reader.error || new Error("Could not read file"));
    reader.readAsBinaryString(file);
  });
